"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.collectionsContractDeployValidationSchema = void 0;
const yup_1 = require("yup");
const yup_rules_1 = require("@dzambalaorg/yup-rules");
exports.collectionsContractDeployValidationSchema = (0, yup_1.object)().shape({
    name: yup_rules_1.titleValidationSchema,
    symbol: yup_rules_1.symbolValidationSchema,
    baseTokenURI: yup_rules_1.urlValidationSchema,
    royalty: yup_rules_1.currencyValidationSchema.max(10000, "form.validations.rangeOverflow"),
    batchSize: (0, yup_1.number)()
        .typeError("form.validations.badInput")
        .required("form.validations.valueMissing")
        .integer("form.validations.badInput")
        .max(10000, "form.validations.rangeOverflow")
        .min(0, "form.validations.rangeUnderflow"),
});
//# sourceMappingURL=validation.js.map